export interface ArticleItem {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  cover: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  content: string;
  isFeatured: boolean;
}

export const articles: ArticleItem[] = [
  {
    id: 'article-001',
    slug: '2024-winter-anime-ranking',
    title: '2024年冬季新番人气排行榜 TOP10，哪部是你的菜？',
    excerpt: '冬季新番已经播出过半，来看看观众们票选出的本季最受欢迎动画排名，你追的番上榜了吗？',
    cover: 'https://readdy.ai/api/search-image?query=Winter%202024%20anime%20season%20collage%2C%20multiple%20anime%20posters%20arranged%20artistically%2C%20cozy%20winter%20atmosphere%2C%20ranking%20list%20theme%2C%20warm%20indoor%20lighting%2C%20professional%20otaku%20room%20setting&width=800&height=450&seq=article-cover-001&orientation=landscape',
    category: 'ranking',
    author: '小樱编辑部',
    publishDate: '2024-02-10',
    readTime: '8分钟',
    tags: ['新番', '排行榜', '2024冬番', '推荐'],
    isFeatured: true,
    content: `<h2>冬季新番大盘点</h2>
<p>2024年冬季新番已经播出过半，各大平台的新番也陆续揭开了神秘面纱。本季度的新番阵容可谓相当豪华，既有备受期待的续作，也有让人眼前一亮的原创作品。</p>
<p>小樱动漫编辑部综合了各大平台的播放数据、观众评分以及社交媒体的讨论热度，为大家整理出了本季度最受欢迎的十部作品。一起来看看你心中的神作有没有上榜吧！</p>
<h3>TOP 1：迷宫饭</h3>
<p>当之无愧的榜首！这部将美食与地下城冒险完美融合的作品，凭借着独特的世界观设定和温暖人心的故事，征服了大量观众。每集都让人垂涎三尺的料理画面配合精彩的冒险剧情，简直是视觉与味觉的双重盛宴。</p>
<h3>TOP 2：我独自升级</h3>
<p>韩漫改编的黑马之作！精致到每一帧都能当壁纸的画面质量，加上爽快的战斗场面，让这部作品迅速获得了极高的人气。主角从最弱到最强的成长历程，让人看得热血沸腾。</p>
<h3>TOP 3：葬送的芙莉莲（下半部分）</h3>
<p>上半部分已经封神，下半部分更是直接封圣。芙莉莲的旅途继续，更多关于生命与时间的哲理思考，配合一如既往的精美制作，让这部作品稳居前三。</p>
<h3>TOP 4-10</h3>
<p>4. 药屋少女的呢喃 —— 古风推理与宫廷剧情的完美结合<br/>
5. 物理魔法使马修 第二季 —— 肌肉笨蛋的魔法世界冒险继续<br/>
6. 香格里拉边境 —— VR游戏题材的惊喜之作<br/>
7. 狩龙人拉格纳 —— 黑暗奇幻的战斗盛宴<br/>
8. 指尖相触恋恋不舍 —— 甜到爆炸的恋爱番<br/>
9. 魔都精兵的奴隶 —— 独特设定的战斗后宫<br/>
10. 不死少女的谋杀闹剧 —— 推理与奇幻的奇妙融合</p>`,
  },
  {
    id: 'article-002',
    slug: 'guoman-rising-2024',
    title: '国漫崛起进行时：2024年最值得期待的国产动画盘点',
    excerpt: '从《雾山五行》到《时光代理人》，国产动画正在用实力证明自己。盘点2024年必看的国产动画。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20showcase%2C%20multiple%20Chinese%20style%20anime%20characters%2C%20traditional%20Chinese%20art%20elements%2C%20modern%20animation%20quality%2C%20ink%20wash%20and%20digital%20blend%2C%20professional%20animation%20art&width=800&height=450&seq=article-cover-002&orientation=landscape',
    category: 'industry',
    author: '动漫观察员',
    publishDate: '2024-02-05',
    readTime: '10分钟',
    tags: ['国漫', '国产动画', '推荐', '产业'],
    isFeatured: true,
    content: `<h2>国漫的黄金时代</h2>
<p>回望过去十年，国产动画经历了从量变到质变的飞跃。从最初被观众诟病"画风粗糙""剧情低幼"，到如今在国内外斩获无数好评，国漫的崛起已经成为不争的事实。</p>
<p>小樱动漫一直致力于为国漫提供最好的展示平台。今天，我们就来盘点一下2024年最值得期待的国产动画作品。</p>
<h3>顶尖制作水准的代表</h3>
<p><strong>《雾山五行》</strong>——以水墨画风震惊业界的现象级作品。每一帧都堪称艺术品，将中国传统美学与现代动画技术完美融合。虽然只有短短几话，但每一话的制作周期和用心程度都让人敬佩。</p>
<p><strong>《时光代理人》</strong>——都市奇幻悬疑题材的标杆之作。精致的画面、紧凑的剧情、深刻的情感刻画，让这部作品成功出圈，吸引了大量非二次元观众的关注。</p>
<h3>不可错过的经典IP</h3>
<p><strong>《一人之下》</strong>——国产动画长篇连载的扛鼎之作。融合了道家文化、武术、异能等元素，构建了一个庞大而自洽的异人世界。随着剧情不断深入，口碑和热度都在持续攀升。</p>
<p><strong>《灵笼》</strong>——科幻末世题材的视觉奇观。庞大的世界观、精细的机械设定、震撼的战斗场面，展现了中国动画在科幻领域的雄心与实力。</p>
<h3>结语</h3>
<p>国漫正在经历最好的时代。越来越多的优秀创作者加入这个行业，越来越多的资本愿意投入优质内容。作为观众，我们能做的就是支持正版，用行动告诉整个行业：我们想要更多更好的国产动画！</p>`,
  },
  {
    id: 'article-003',
    slug: 'ghibli-classic-review',
    title: '吉卜力经典回顾：那些陪伴我们成长的动画电影',
    excerpt: '从《龙猫》到《千与千寻》，吉卜力工作室的作品承载了无数人的童年记忆与感动。',
    cover: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20classic%20movie%20collage%2C%20Totoro%20Spirited%20Away%20Howl%20Castle%20artworks%2C%20nostalgic%20and%20magical%20atmosphere%2C%20soft%20watercolor%20texture%2C%20heartwarming%20Japanese%20animation%20style&width=800&height=450&seq=article-cover-003&orientation=landscape',
    category: 'review',
    author: '怀旧动画迷',
    publishDate: '2024-01-28',
    readTime: '12分钟',
    tags: ['吉卜力', '经典', '回顾', '影评'],
    isFeatured: false,
    content: `<h2>吉卜力的魔法世界</h2>
<p>说起日本动画电影，吉卜力工作室是一个绕不开的名字。由宫崎骏、高畑勋等人创立的吉卜力工作室，在近四十年的时间里，为全世界观众奉献了一部又一部令人难忘的动画杰作。</p>
<h3>《龙猫》—— 纯真的森林童话</h3>
<p>1988年上映的《龙猫》可能是吉卜力最温暖的作品。没有复杂的剧情，没有反派，只有一个关于童真和自然的美好童话。那只毛茸茸的大龙猫，成为了吉卜力的标志，也成为了无数人心中最柔软的回忆。</p>
<h3>《千与千寻》—— 奥斯卡加冕的巅峰</h3>
<p>2001年的《千与千寻》不仅在日本创下了至今无人打破的票房纪录，更拿下了奥斯卡最佳动画长片奖。千寻在神灵世界中的冒险，蕴含着关于成长、勇气和环保的深刻主题。</p>
<h3>《哈尔的移动城堡》—— 战火中的浪漫</h3>
<p>改编自英国作家戴安娜·韦恩·琼斯的同名小说，宫崎骏用他天马行空的想象力构建了一座在大地上行走的魔法城堡。战争与和平、诅咒与爱、外表与内心——这些深刻的主题在唯美的画面中得到了完美的呈现。</p>
<h3>《幽灵公主》—— 人与自然的史诗</h3>
<p>1997年的《幽灵公主》是宫崎骏最宏大的作品之一。以日本的室町时代为背景，讲述了人类文明与自然神灵之间的激烈冲突。这部作品深刻地探讨了人与自然的关系，其主题至今仍然具有强烈的现实意义。</p>`,
  },
  {
    id: 'article-004',
    slug: 'beginner-anime-guide',
    title: '动漫入坑指南：给新手的片单推荐与观看顺序建议',
    excerpt: '不知道从哪里开始看动漫？这份新手友好的片单推荐帮你轻松入门二次元世界。',
    cover: 'https://readdy.ai/api/search-image?query=Beginner%20anime%20watching%20guide%2C%20cozy%20room%20with%20anime%20posters%20on%20wall%2C%20laptop%20playing%20anime%2C%20warm%20ambient%20lighting%2C%20casual%20otaku%20lifestyle%2C%20welcoming%20atmosphere&width=800&height=450&seq=article-cover-004&orientation=landscape',
    category: 'guide',
    author: '小樱编辑部',
    publishDate: '2024-01-20',
    readTime: '15分钟',
    tags: ['新手', '入门', '推荐', '片单'],
    isFeatured: false,
    content: `<h2>欢迎来到动漫的世界！</h2>
<p>你可能是因为朋友推荐，或者是被某部热门作品吸引，开始对动漫产生了兴趣。但面对海量的番剧，你可能会感到迷茫——该从哪里开始看？别担心，小樱动漫为你准备了一份新手友好的入坑指南。</p>
<h3>入门推荐：轻松愉快的日常番</h3>
<p>如果你是第一次接触动漫，建议从轻松愉快的日常番开始。这类作品节奏舒缓、剧情简单、氛围温暖，非常适合新手。</p>
<p>推荐作品：《间谍过家家》《辉夜大小姐想让我告白》《轻音少女》《日常》</p>
<h3>进阶之选：精彩刺激的热血番</h3>
<p>如果你已经适应了动漫的表现方式，可以尝试一些热血战斗类作品。精彩的打斗场面、热血的剧情发展、深刻的角色塑造，会让你欲罢不能。</p>
<p>推荐作品：《鬼灭之刃》《咒术回战》《进击的巨人》</p>
<h3>高能预警：烧脑悬疑番</h3>
<p>当你已经是一名成熟的动漫观众，可以挑战一些剧情复杂、设定精巧的作品。这类作品往往需要全神贯注地观看，错过一个细节可能就会影响对后续剧情的理解。</p>
<p>推荐作品：《命运石之门》《死亡笔记》《PSYCHO-PASS 心理测量者》</p>
<h3>国漫入门推荐</h3>
<p>不要忘了国产动画也有大量优秀作品！推荐从《时光代理人》《雾山五行》《罗小黑战记》开始你的国漫之旅。</p>`,
  },
  {
    id: 'article-005',
    slug: 'sakura-anime-platform-intro',
    title: '小樱动漫平台完全使用指南：畅享极致追番体验',
    excerpt: '了解小樱动漫平台的所有功能特性，包括高清播放、多端同步、弹幕互动等，让你的追番之旅更加顺畅。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20anime%20streaming%20platform%20interface%2C%20clean%20dark%20UI%20with%20anime%20thumbnails%2C%20sakura%20petals%20decorative%20elements%2C%20professional%20web%20design%2C%20user%20friendly%20interface&width=800&height=450&seq=article-cover-005&orientation=landscape',
    category: 'guide',
    author: '小樱编辑部',
    publishDate: '2024-02-01',
    readTime: '6分钟',
    tags: ['小樱动漫', '使用指南', '平台', '功能'],
    isFeatured: false,
    content: `<h2>欢迎来到小樱动漫</h2>
<p>小樱动漫是专注于正版高清动漫内容的在线观看平台。我们致力于为每一位动漫爱好者提供最优质的观看体验。</p>
<h3>高清画质，沉浸体验</h3>
<p>小樱动漫全站支持1080P高清播放，部分热门作品更提供4K画质选项。无论你是在大屏幕上欣赏剧场版的精美画面，还是在手机上追番，都能获得最佳的视觉体验。</p>
<h3>多端同步，随时随地</h3>
<p>支持Web端、移动端、平板等多设备访问。追番进度、收藏列表自动云端同步，无论你切换到哪个设备，都能无缝衔接。</p>
<h3>丰富资源，正版授权</h3>
<p>小樱动漫与各大版权方深度合作，拥有海量正版动漫资源。日漫、国漫、剧场版、经典动画，应有尽有。新番同步更新，让你第一时间看到最新内容。</p>
<h3>社区互动，追番不孤单</h3>
<p>每一部作品都有专属讨论区，你可以在这里与其他动漫爱好者交流心得、分享感想。弹幕功能让你在看番的同时感受与其他观众一起追番的乐趣。</p>`,
  },
  {
    id: 'article-006',
    slug: 'anime-music-recommend',
    title: '耳朵怀孕系列：那些一听就忘不了的动漫神曲 TOP20',
    excerpt: '经典的动漫离不开经典的配乐。盘点动漫史上那些让人一听就起鸡皮疙瘩的神级OP、ED与OST。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20music%20concert%20theme%2C%20headphones%20with%20music%20notes%20floating%2C%20anime%20style%20illustration%2C%20warm%20sunset%20colors%2C%20emotional%20and%20nostalgic%20atmosphere%2C%20professional%20art&width=800&height=450&seq=article-cover-006&orientation=landscape',
    category: 'ranking',
    author: '音乐番爱好者',
    publishDate: '2024-01-25',
    readTime: '10分钟',
    tags: ['音乐', '动漫歌曲', '排行榜', '推荐'],
    isFeatured: false,
    content: `<h2>音乐是动漫的灵魂</h2>
<p>一部优秀的动漫作品，离不开出色的配乐。一首好的OP或ED不仅能够完美契合作品的主题，更能成为跨越时空的经典，让人在多年之后听到依然热泪盈眶。</p>
<h3>燃系神曲</h3>
<p>《紅蓮の弓矢》—— 进击的巨人OP1。这首歌几乎定义了"燃"这个字。当"Sie sind das Essen und wir sind die Jäger!"这句德语响起的时候，浑身的鸡皮疙瘩都起来了。</p>
<p>《Gurenge》—— 鬼灭之刃OP。LiSA极具爆发力的嗓音配合炭治郎的战斗画面，简直完美。</p>
<h3>治愈神曲</h3>
<p>《secret base ～君がくれたもの～》—— 未闻花名ED。这首歌响起的时候，准备好纸巾就对了。</p>
<p>《ひまわりの約束》—— 哆啦A梦：伴我同行主题曲。秦基博温暖的声线让人瞬间回到童年。</p>
<h3>经典永流传</h3>
<p>《残酷な天使のテーゼ》—— 新世纪福音战士OP。跨越二十多年依然不过时的经典中的经典。</p>
<p>《めざせポケモンマスター》—— 宠物小精灵初代OP。光是前奏一响，8090后的DNA就动了。</p>`,
  },
];

export const getArticleBySlug = (slug: string): ArticleItem | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getFeaturedArticles = (): ArticleItem[] => {
  return articles.filter((a) => a.isFeatured);
};

export const getRelatedArticles = (currentSlug: string, count: number = 3): ArticleItem[] => {
  const current = articles.find((a) => a.slug === currentSlug);
  if (!current) return articles.slice(0, count);
  return articles
    .filter((a) => a.slug !== currentSlug && a.category === current.category)
    .slice(0, count);
};